export default __webpack_public_path__ + "static/media/google.40fa8bfe.svg";